import type { FaireProductEntity } from "../../entity_types/product";

export const p_avmdpaxq9u: FaireProductEntity = {
  token: "p_avmdpaxq9u",
  type: "product",
  name: "Ceramic Modern Sitting Pretty Kitty Figurine - White, 7 in.",
  brandToken: "b_oigrk5zybt",
  brandName: "Sagebrook Home",
  imageUrl:
    "https://cdn.faire.com/fastly/b0610e159fd5989bdedf36434b5677c6e32f38fc24f334645eab470b6d39a7ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cf9d40289830172d449345a2a80e4b91c813e59df192c2d73ad317ff18910165.jpeg",
    "https://cdn.faire.com/fastly/b3672852c087c9850a1e2414542a65f280b0bbf6ea3b2aeb89ec64c6187a98fb.jpeg",
    "https://cdn.faire.com/fastly/16b4c167b4a863fd0866995321f8c77be58dcd31359dd6e576a606df5a84f23b.jpeg",
    "https://cdn.faire.com/fastly/9a1989e4fc8053c113c6c16660b6de463825ad4987ae88374c4aae9009c0bfa8.jpeg",
    "https://cdn.faire.com/fastly/876f4b7e9c059e8e77dc7ab666386c715b9c37be188c08f54b6a7c39b67b1005.jpeg",
    "https://cdn.faire.com/fastly/d4374e96b7ebf21043b7a3e67d4eab0a9589ecec156f1eb008d97885e9431cac.jpeg",
    "https://cdn.faire.com/fastly/b321ec550894fb8beecf1bf05f0504c1089a1eb96fa033d80fb1e01941e470cd.jpeg",
    "https://cdn.faire.com/fastly/0b22c6cb08f43450c0d248a7ef910e9edc8de68546d89e3a501da326729cdb9e.jpeg",
    "https://cdn.faire.com/fastly/d34c595584d145b387635ef9c3e918b4f976d0648db443f98fb9096700e36b2a.jpeg",
    "https://cdn.faire.com/fastly/5e9ce6b3b684af388e284b9e45d38884882c669a00059003cc2cd6a2344f47eb.jpeg",
    "https://cdn.faire.com/fastly/44905345682297dba8fef0f526e0503ac8a2402a3a45213307c9c0bf3346763f.jpeg",
    "https://cdn.faire.com/fastly/c4eca9b1f70a3474661ee48e57c5949e4f299dffe9f929ca11bf72f77be42882.jpeg",
    "https://cdn.faire.com/fastly/03b13efcee1651eef8c34638930d99ce6f48e6ebd2783acccdcaa29e10b5524f.jpeg",
    "https://cdn.faire.com/fastly/1b9ee9d187d9d819c772884d0a5ec999951535446e7939188028d9604ef7a69f.jpeg",
  ],
  priceDollars: 14.2,
  description:
    "• ADORABLE CAT-SHAPED DESIGN - This unique ceramic vase features a charming cat shape, adding a playful yet elegant touch while making a perfect statement piece for any space. Ideal for cat lovers and those who appreciate creative home accents.\n• HIGH-QUALITY STONEWARE CONSTRUCTION - Crafted from durable stoneware ceramic, this cat vase has a sturdy build with a smooth, glossy white finish. Designed to last, it resists chipping and cracking, ensuring long-term beauty and functionality.\n• VERSATILE DECOR & FUNCTIONALITY - Ideal as a decorative vase for fresh flowers, dried arrangements, or as a standalone ornament. Whether placed on a mantel, desk, shelf, or windowsill, this stylish piece elevates any room's aesthetic.",
  tags: [],
  msrpDollars: 35.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:37.686Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
